<template>
  <div>
    <div
      id="border"
      class="border-surface-200 dark:border-surface-800"
      :class="{ 'bar-animated': props.loading }"
    >
      <div class="bar bg-surface-200 dark:bg-surface-800"></div>
      <div class="bar bg-surface-200 dark:bg-surface-800"></div>
      <div class="bar bg-surface-200 dark:bg-surface-800"></div>
      <div class="bar bg-surface-200 dark:bg-surface-800"></div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({ loading: Boolean });
</script>

<style scoped lang="scss">
#border {
  display: flex;
  align-items: end;
  justify-content: space-around;
  text-align: center;
  gap: 20px;
  border-width: 10px;
  border-radius: 14px;
  padding: 10px;
  height: 100%;
  width: 100%;
  max-width: 400px;
  max-height: 400px;
}

.bar {
  width: 20%;
}

.bar-animated > .bar {
  animation-name: bar-height;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes bar-height {
  from {
    height: 20%;
    opacity: 0.1;
  }
  to {
    height: 80%;
    opacity: 1;
  }
}

#border div:nth-child(1) {
  height: 20%;
  animation-delay: -0s;
}

#border div:nth-child(2) {
  height: 40%;
  animation-delay: -0.25s;
}

#border div:nth-child(3) {
  height: 60%;
  animation-delay: -0.5s;
}

#border div:nth-child(4) {
  height: 80%;
  animation-delay: -1s;
}
</style>
